import { Action } from 'redux';

import { CreateNewContentInfoRequest, CreateNewFlow, CreateNewProject, CreateNewSchedule, CreateNewSite, CreateNewWorkbook } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface CreateNewContentAction extends Action {
  projectId?: string;
}

export interface CreateNewContentInfoRequestAction extends CreateNewContentAction {}

export function createNewContentInfoRequest(): CreateNewContentAction {
  return {
    type: CreateNewContentInfoRequest
  };
}

export interface CreateNewFlowAction extends CreateNewContentAction {}

export function createNewFlow(): CreateNewFlowAction {
  return {
    type: CreateNewFlow
  };
}

export interface CreateNewProjectAction extends CreateNewContentAction {}

export function createNewProject(projectId: string): CreateNewProjectAction {
  return {
    type: CreateNewProject,
    projectId: projectId
  };
}

export const isCreateNewProjectAction = isActionFactory<CreateNewProjectAction>(CreateNewProject);

export interface CreateNewWorkbookAction extends CreateNewContentAction {}

export function createNewWorkbook(projectId: string): CreateNewContentAction {
  return {
    type: CreateNewWorkbook,
    projectId: projectId
  };
}

export interface CreateNewSiteAction extends CreateNewContentAction {}

export function createNewSite(): CreateNewSiteAction {
  return {
    type: CreateNewSite
  };
}


export interface CreateNewScheduleAction extends CreateNewContentAction {}

export function createNewSchedule(): CreateNewScheduleAction {
  return {
    type: CreateNewSchedule
  };
}
